export default __webpack_public_path__ + "static/media/Raiontech.90de2bc3.png";